import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useSelector } from 'react-redux';
import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { AREA_FILTERS_MAP } from './constants';
import { selectSquareMeterAreaFilters } from 'shared/selectors/advancedFilters';

export const SquareMeterAreaContainer: FC = () => {
  const areaFilterKeys = useSelector(selectSquareMeterAreaFilters);

  return (
    <AdvancedFilterRow label="Площадь, м²">
      <InlineFilterGroup>
        {areaFilterKeys.map(areaFilterKey => {
          const AreaFilter = AREA_FILTERS_MAP[areaFilterKey];

          return <AreaFilter key={areaFilterKey} />;
        })}
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
